export type AriaSort = "ascending" | "descending" | "none" | undefined;

export const PRIMARY_SORT_INDEX: number = 0;

const ARIA_SORT_BY_DIRECTION: Readonly<Record<string, AriaSort>> = {
  asc: "ascending",
  desc: "descending",
};

export const ariaSortOf = (
  canSort: boolean,
  sorted: false | "asc" | "desc",
  sortIndex: number,
): AriaSort => {
  if (!canSort) return undefined;
  if (sortIndex !== PRIMARY_SORT_INDEX) return "none";

  return ARIA_SORT_BY_DIRECTION[String(sorted)] ?? "none";
};
